export function formatCurrency(number: number | undefined) {
    if (number === null || number === undefined) {
        return "";
    }

    var format = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0})
    return format.format(number);
}